import React from "react";
import { Link } from "react-router-dom";

import { PageHeader } from "../components.jsx";

export default function NotFound() {
  return (
    <>
      <PageHeader title="Not found" />
      <div className="page-body">
        <div className="empty-state">
          <h3>404</h3>
          <p>
            The page you're looking for doesn't exist.{" "}
            <Link to="/">Back to dashboard</Link>
          </p>
        </div>
      </div>
    </>
  );
}
